export default __webpack_public_path__ + "static/media/ssl.aadef330.png";